import React, { useState, useEffect } from "react";

import { Row, Col, Input, Pagination, Card } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import { API_URL } from "../../../../constants";
import useAxios from "@use-hooks/axios";
// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/InsuranceKnowledge/Books/Books.css";

// JS Files
import BooksCard from "./BooksCard.js";
import ArticlesTable from "./ArticlesTable.js";
import ArticlesCategory from "./ArticlesCategory.js";

const BooksArticlesMain = (props) => {
  const [books, setBooks] = useState([]);
  const [articles, setArticles] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(null);
  const [current, setCurrent] = useState(null);
  const [articleCategory, setArticleCategory] = useState("bime");
  const [type, setType] = useState("bime");


  const getBooks = useAxios({
    url: `${API_URL}/Book_Service/`,
    trigger: [],
    customHandler: (err, res) => {
      if (res) {
        console.log("data", res.data);
        setBooks(res.data);
      }
    },
  });

  const get_type = (type_number) => {
    switch (type_number) {
      case "bime":
        return 0;
      case "law":
        return 1;
      case "it":
        return 2;
      case "bank":
        return 3;
      case "translate":
        return 4;
      case "more":
        return 5;
      default:
        return;
    }
  };

  const getArticles = useAxios({
    url: `${API_URL}/Article_Service/?page=${page}&type=${get_type(
      articleCategory
    )}`,
    trigger: [],
    customHandler: (err, res) => {
      if (res) {
        console.log("data articles", res.data);

        setArticles(
          res.data.results.filter(
            (item) => item.type === parseInt(get_type(articleCategory))
          )
        );
        setTotal(res.data.count);
        setCurrent(res.data.current);
      }
    },
  });

  const on_change_types = (type) => {
    console.log("type", type);
    setArticleCategory(type);
  };

  useEffect(() => {
    getArticles.reFetch();
  }, [articleCategory]);
  const changePagination = (page, pageSize) => {
    setPage(page);
    // setFetch(true);
    getArticles.reFetch();
  };

  return props.size === "laptopdesktop" ? (
    <div className="BooksBackground">
      <div style={{ paddingTop: "100px" }}>
        <Center>
          <p className="mainTitle mainTitleBorderRight mainTitleBorderLeft" style={{color:"#fff"}}>
            <strong>کتاب، مقالات و پایان نامه ها</strong>
          </p>
        </Center>
      </div>
      <Row style={{ marginTop: "150px" }}>
        <Col span={3}></Col>
        <Col span={18}>
          {getBooks.response?.data && (
            <BooksCard
              history={props.history}
              books={books.slice(0,4)}
              size="laptopdesktop"
            />
          )}
        </Col>
        <Col span={3}></Col>
      </Row>
      <Margin top={3}></Margin>
      <Center>
        <Margin top={5}>
          <div>
            <p className="subTitle">
              <strong>
                مقالات و پایان نامه ها
              </strong>
            </p>
          </div>
        </Margin>
      </Center>
      <Center>
        <div className="subTitleHR"></div>
      </Center>
      <Margin top={3}></Margin>
      <div style={{ backgroundColor: "#ededed" }}>
        <Margin top={3}></Margin>
        <Row>
          <Col span={1}></Col>
          <Col span={22}>
            <Row>
              <Col span={20}>
                <Center>
                  {getArticles.response?.data && (
                    <ArticlesTable
                      history={props.history}
                      articles={articles}
                      size="laptopdesktop"
                    />
                  )}
                </Center>
              </Col>
              <Col span={4}>
                <Margin top={5}></Margin>
                <ArticlesCategory
                  set_type={on_change_types}
                  category={articleCategory}
                  size="laptopdesktop"
                />
              </Col>
            </Row>
            <Row>
              <Col span={20}>
                {getArticles.response?.data && (
                  <Pagination
                    style={{ textAlign: "left", fontFamily: "IranSans" }}
                    simple
                    current={current}
                    pageSize={parseInt(getArticles.response?.data?.pageSize)}
                    total={total === 0 ? 1 : total}
                    onChange={changePagination}
                  />
                )}{" "}
              </Col>
              <Col span={4}></Col>
            </Row>
            <Margin bottom={3}></Margin>
          </Col>
          <Col span={1}></Col>
        </Row>
      </div>
    </div>
  ) : props.size === "tablet" ? (
      <div className="BooksBackground">
        <div style={{ paddingTop: "75px" }}>
          <Center>
            <p className="mainTitleTablet mainTitleBorderRight mainTitleBorderLeft" style={{color:"#fff"}}>
              <strong>کتاب، قوانین و مقالات</strong>
            </p>
          </Center>
        </div>
        <Row style={{ marginTop: "75px" }}>
          <Col span={3}></Col>
          <Col span={18}>
            {getBooks.response?.data && (
              <BooksCard
                history={props.history}
                books={books.slice(0,3)}
                size="tablet"
              />
            )}
          </Col>
          <Col span={3}></Col>
        </Row>
        <Margin top={3}></Margin>
        <Center>
          <Margin top={4}>
            <div>
              <p className="subTitleTablet">
                <strong>
                  مقالات و پایان نامه ها
              </strong>
              </p>
            </div>
          </Margin>
        </Center>
        <Center>
          <hr className="subTitleHRTablet"/>
        </Center>
        <Margin top={3}></Margin>
        <div style={{ backgroundColor: "#ededed" }}>
          <Margin top={3}></Margin>
          <Row>
            <Col span={1}></Col>
            <Col span={22}>
              <Row>
                <Col span={18}>
                  {getArticles.response?.data && (
                    <ArticlesTable
                      history={props.history}
                      articles={articles}
                      size="tablet"
                    />
                  )}
                </Col>
                <Col span={1}></Col>
                <Col span={5}>
                  <Margin top={5}></Margin>
                  <ArticlesCategory
                    set_type={on_change_types}
                    category={articleCategory}
                    size="tablet"
                  />
                </Col>
              </Row>
              <Row>
                <Col span={20}>
                  {getArticles.response?.data && (
                    <Pagination
                      style={{ textAlign: "left", fontFamily: "IranSans" }}
                      simple
                      current={current}
                      pageSize={parseInt(getArticles.response?.data?.pageSize)}
                      total={total === 0 ? 1 : total}
                      onChange={changePagination}
                    />
                  )}{" "}
                </Col>
                <Col span={4}></Col>
              </Row>
              <Margin bottom={3}></Margin>
            </Col>
            <Col span={1}></Col>
          </Row>
        </div>
      </div>
  ) : (
    <div className="BooksBackground">
      <div style={{ paddingTop: "35px" }}>
        <Center>
          <p style={{color:"#fff"}} className="mainTitleMobile mainTitleBorderRightMobile mainTitleBorderLeftMobile">
            <strong>کتاب، قوانین و مقالات</strong>
          </p>
        </Center>
      </div>
      <Row style={{ marginTop: "100px" }}>
        <Col span={1}></Col>
        <Col span={22}>
          {getBooks.response?.data && (
            <BooksCard
              history={props.history}
              books={books.slice(0,4)}
            />
          )}
        </Col>
        <Col span={1}></Col>
      </Row>
      <Margin top={3}></Margin>
      <Center>
        <Margin top={4}>
          <div>
            <p className="subTitleMobile">
              <strong>
                مقالات و پایان نامه ها
              </strong>
            </p>
          </div>
        </Margin>
      </Center>
      <Center>
        <div className="subTitleHRMobile"></div>
      </Center>
      <Margin top={3}></Margin>
      <div style={{ backgroundColor: "#ededed" }}>
        <Margin top={3}></Margin>
        
            <Row>
              <Col span={2}></Col>
              <Col span={20}>
                <Margin top={3}></Margin>
                <ArticlesCategory
                  set_type={on_change_types}
                  category={articleCategory}
                />
              </Col>
              <Col span={2}></Col>
            </Row>
            <Margin top={3}></Margin>
            <Row>
                <Col span={1}></Col>
                  <Col span={22}>
                    {getArticles.response?.data && (
                      <ArticlesTable
                        history={props.history}
                        articles={articles}
                      />
                    )}
                  </Col>
                <Col span={1}></Col>
            </Row>
            <Row>
              <Col span={20}>
                {getArticles.response?.data && (
                  <Pagination
                    style={{ textAlign: "left", fontFamily: "IranSans" }}
                    simple
                    current={current}
                    pageSize={parseInt(getArticles.response?.data?.pageSize)}
                    total={total === 0 ? 1 : total}
                    onChange={changePagination}
                  />
                )}{" "}
                <Margin bottom={4}></Margin>
              </Col>
              <Col span={4}></Col>
            </Row>
          
          
        
      </div>
    </div>
  );
};

export default BooksArticlesMain;
